import React, { useState } from "react";
import { FileNameSection } from "components/file_name_section";
import { Form } from "react-bootstrap";
import { SlCloudUpload } from "react-icons/sl";

export const InputFileComponent = ({
  label = null,
  handleChange,
  id,
  ...props
}) => {
  const [fileName, setFileName] = useState("");
  const handleFileChange = (e) => {
    console.log("e", e.target.files);
    const file = e.target.files;
    if (file.length > 0) {
      setFileName(file[0].name);
      handleChange(file[0]);
    } else {
      setFileName("");
    }
    console.log(file);
  };
  return (
    <Form.Group className="p-2 px-3 rounded-3 shadow-sm">
      {label && (
        <Form.Label className="text-dark fw-semibold">{label}</Form.Label>
      )}
      <div className="position-relative d-flex justify-content-between align-items-center gap-3">
        <FileNameSection fileName={fileName || "No File Selected"} />
        <div>
          <input
            type="file"
            id={id}
            className="d-none"
            ref={props?.ref || null}
            onChange={handleFileChange}
          />
          <label
            htmlFor={id}
            className="btn btn-primary-gradient text-nowrap fw-normal px-md-4 py-2"
          >
            <SlCloudUpload className="d-md-none" />
            <span className="d-none d-md-block">Upload File</span>
          </label>
        </div>
      </div>
    </Form.Group>
  );
};
